/* eslint-disable @nx/enforce-module-boundaries */
import { Component, inject } from '@angular/core';
import { SummaryCardsCollectionComponent } from '../summary-cards-collection/summary-cards-collection.component';
import { SummaryVersionDetailsComponent } from '../summary-version-details/summary-version-details.component';
import { SummaryService } from '../../services/summary.service';

@Component({
  selector: 't-llevo-summary-main',
  standalone: true,
  imports: [
    SummaryCardsCollectionComponent,
    SummaryVersionDetailsComponent,
  ],
  template: `
    <t-llevo-summary-cards-collection></t-llevo-summary-cards-collection>
    <div class="row my-3">
      <div class="col-md-12 col-lg-6">
        <t-llevo-summary-version-details
          versionTitle="Última versión aplicación conductor"
          [dataObs]="summarySrv.driverAppLastVersion$"
        ></t-llevo-summary-version-details>
      </div>
      <div class="col-md-12 col-lg-6">
        <t-llevo-summary-version-details
          versionTitle="Última versión aplicación cliente"
          [dataObs]="summarySrv.clientAppLastVersion$"
        ></t-llevo-summary-version-details>
      </div>
    </div>
  `
})
export class SummaryMainComponent {
  protected summarySrv = inject(SummaryService);

  constructor(){
    this.summarySrv.getVersionsData().subscribe()
  }
}
